module.exports = __webpack_public_path__ + "static/media/screen logo vertical large.92427ae2.png";